import { render, staticRenderFns } from "./boxsvg1.vue?vue&type=template&id=0dbab0ba&scoped=true&"
var script = {}
import style0 from "./boxsvg1.vue?vue&type=style&index=0&id=0dbab0ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbab0ba",
  null
  
)

export default component.exports